<template>
  <!--  -->
  <div>
    <el-dialog
      title="立即退费"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :center="true"
      :show-close="false"
      width="50%"
    >
      <span>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="退费原因" prop="refundCause">
            <el-input
              type="textarea"
              v-model="ruleForm.refundCause"
            ></el-input>
          </el-form-item>
          <el-form-item label="附件" prop="accessory">
            <el-upload
              :action="uploadUrl"
              list-type="picture-card"
              :on-success="uploadSuccess"
              :before-upload="beforeAvatarUpload"
              :on-exceed="handleExceed"
              :file-list="fileArr"
              :limit="3"
            >
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{ file }">
                <img class="el-upload-list__item-thumbnail" :src="file.url" />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>

                  <span
                    v-if="!disabled"
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible2">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { setMoneyback } from "@/api/index.js";

export default {
  data() {
    return {
      uploadUrl: process.env.VUE_APP_BASE_API + "sys/upload/fileUpload",
      dialogImageUrl: "",
      fileArr: [],
      dialogVisible: false,
      dialogVisible2: false,
      disabled: false,
      ruleForm: {
        refundCause: "",
        accessory: "",
        orderTreatId: "",
        remark: "立即退款",
      },
      rules: {
        refundCause: [
          { required: true, message: "请填写退费原因", trigger: "blur" },
        ],
        accessory: [
          { required: true, message: "请上传附件", trigger: "change" },
        ],
      },
    };
  },

  methods: {
        //限制图片格式
    beforeAvatarUpload(file) {
      console.log("限制图片格式:", file.type);
      let isJPG = false;
      if (file.type === "image/jpeg" || file.type === "image/png") {
        isJPG = true;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传文件只能是 JPG和PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    //限制上传数量
         handleExceed(files, fileList) {
        this.$message.error(`当前限制上传 3 张图片`);
      },
    //上传成功
    uploadSuccess(response, file, fileList) {
      this.fileArr = fileList;
      console.log(":", fileList);
    },
    open(id) {
      this.ruleForm.orderTreatId = id;
      console.log("id:", id);
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
      this.$refs["ruleForm"].resetFields();
    },
    //删除图片
    handleRemove(file) {
      let { name } = file;
      this.fileArr.forEach((e, i) => {
        if (e.name == name) {
          this.fileArr.splice(i, 1);
        }
      });
    },
    //查看大图
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible2 = true;
    },

    submitForm(formName) {
      let arr = [];
      if (this.fileArr.length != 0) {
        this.fileArr.forEach((e) => {
          arr.push(e.response.result.relativePath);
        });
      }
      this.ruleForm.accessory = arr.join(",");
      this.$refs[formName].validate((valid) => {
        console.log("valid:", valid);
        console.log("submit:", this.ruleForm);

        if (valid) {
          setMoneyback(this.ruleForm).then((res) => {
            if(res.success){
              this.close()
              this.$emit("success",this.ruleForm.orderTreatId)
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.page {
}
</style>